import api from './axios'

/**
 * Get dashboard statistics
 * @returns {Promise<object>}
 */
export const getStats = async () => {
  const response = await api.get('/dashboard/stats')
  return response.data
}

/**
 * Get recent activity
 * @param {number} limit 
 * @returns {Promise<Array>}
 */
export const getRecentActivity = async (limit = 10) => {
  const response = await api.get('/dashboard/recent-activity', {
    params: { limit }
  })
  return response.data
}

/**
 * Get expiring contracts
 * @param {number} days 
 * @returns {Promise<Array>}
 */
export const getExpiringContracts = async (days = 30) => {
  const response = await api.get('/dashboard/expiring-contracts', {
    params: { days }
  })
  return response.data
}